import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export type errorTextObj = 'invalidRange' | 'minDate' | 'maxDate';

export const dateErrorTextObj: Record<errorTextObj, string> = {
  maxDate: 'Date cannot be in the future',
  minDate: 'Date cannot be 3 years before today’s date',
  invalidRange: 'Start date cannot be after end date',
};

export const isValidNgbDate = (date: NgbDate): boolean => {
  if (!date) {
    return;
  }
  const validYear = date.year.toString().length === 4;
  const validMonth = date.month.toString().length === 1 || date.month.toString().length === 2;
  const validDay = date.day.toString().length === 1 || date.day.toString().length === 2;
  return validYear && validMonth && validDay;
};

export const getNgbDate = (date: string): NgbDateStruct => {
  const newDate: string[] = date.split('/');
  return { month: +newDate[0], day: +newDate[1], year: +newDate[2] };
};
